// styles/components/Nav.styles.js

import styled from 'styled-components'
import { motion } from 'framer-motion'
import * as breakpoints from '../../styles/abstracts/_breakpoints'

const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

export const Div = styled(motion.div)`
  position: relative;
  z-index: 100000;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const HamburgerNav = styled(motion.nav)`
  display: none;
  justify-items: center;
  align-items: center;
  height: 3rem;
  width: auto;
  cursor: pointer;
  z-index: 0;

  @media ${xxSmallDevices} {
    display: inline-block;
  }
  @media ${xxSmallDevicesLandscape} {
    display: inline-block;
    margin: auto;
  }
  @media ${extraSmallDevices} {
    display: inline-block;
    margin: auto;
  }
  @media ${extraSmallDevicesLandscape} {
    display: inline-block;
  }
  @media ${mediumDevices} {
    display: inline-block;
  }
  @media ${mediumDevicesLandscape} {
    display: inline-block;
    align-items: end !important;
    justify-items: end !important;
    justify-self: end !important;
  }
  @media ${largeDevices} {
    display: inline-block;
    align-items: end !important;
    justify-items: end !important;
    justify-self: end !important;
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const MotionPath = styled(motion.path)`
  z-index: 1001;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const SideBarDiv = styled(motion.div)`
  position: fixed;
  overflow-y: auto;
  overscroll-behavior: contain;
  inset: 0;
  width: 100%;
  height: 100dvh;
  padding: 0;
  background: #fff;
  z-index: 100000;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const MotionLi = styled(motion.li)`
  text-align: center;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 2;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const MotionP = styled(motion.p)`
  text-decoration-line: ${(props) => (props.selected ? 'underline' : 'none')};
  font-size: 2rem;
  width: 100%;
  cursor: pointer;
  text-align: center;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const MotionUl = styled(motion.ul)`
  padding: 0;
  z-index: 999;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`
